export const CORRELATION_ID_KEY = "msite-sms-locator-correlation-id"
// export const SAVED_DATA = "msite-bpass-saved-data"

// export const STEP_1 = "step1"
// export const STEP_2 = "step2"
// export const STEP_3 = "step3"
// export const STEP_4 = "step4"
// export const STEP_5 = "step5"
// export const SUMMARY = "summary"

//#region SMS Locator V2 Martin Armand ENOBO
export enum APIResult {
  SUCCESS = "success",
  FAILURE = "failure",
};

export enum Endpoints {
  oauth_pos = 'https://sso.europassistance.it/auth/realms/EA-UAT/protocol/openid-connect/token',
  check_get = 'http://eaittwes008-nco.milano.ea.it:98/Locator/Check/',
  getpoi_get = 'http://eaittwes008-nco.milano.ea.it:98/Locator/GetPoi/',
  complete_post = 'http://eaittwes008-nco.milano.ea.it:98/Locator/Complete/',
  complete_exit_post='http://eaittwes008-nco.milano.ea.it:98/Locator/Complete/'
};

export const CLIENT_ID = 'ncox_smslocator_app_client';
export const CLIENT_SECRET = 'bb3ba19f-ce6b-4839-a16a-056787d38d7f';
export const GRANT_TYPE = 'client_credentials';
export const SCOPE = 'ncox_smslocator_api create read update delete';
export const AUDIENCE = 'ncox_smslocator_api';
export const EA_VERSION = 'Ver. 2.0';



// 12040252 --> EURA
// 12040247 --> MONDIAL
// 12040250 --> PAS
// 12040241 --> IPAS
//#endregion
